import React from 'react';
const BroSplitPlan = () => {
  return (
    <div className="bro-split-plan-container" id="workoutplans">
      <div className="bro-split-content">
        <h1>Sweat out all those bad vibes with our ultimate Push Pull Leg Plan !</h1>
        <p>Follow the Push Pull Leg plan and achieve your fitness goals. Each day is dedicated to a specific muscle group to maximize growth and recovery.</p>
        <div className="workout-buttons">
          <a className="workout-button" href="#push">Push Workout</a>
          <a className="workout-button" href="#pull">Pull Workout</a>
          <a className="workout-button" href="#pplleg">Leg Workout</a>
        </div>
      </div>
    </div>
  );
};

export default BroSplitPlan;
